import React, { useState, useEffect } from 'react';
import { Table, TableBody, Grid, TableCell, TableContainer, MenuItem, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import AddCampaña from './AddCampaña';
import { useAccesos } from '../contexts/AccesosContext';


function GestionCampaña() {

    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [campanias, setCampanias] = useState([]);
    const [editCampania, setEditCampania] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [campaniaToDelete, setCampaniaToDelete] = useState(null);
    const [estados, setEstados] = useState([]);
    const [estadoFiltro, setEstadoFiltro] = useState('');
    const { user } = useUser();   
    const { tienePermiso } = useAccesos();
   
    // const fetchCampanias = async () => {
    //             try {
    //                 const response = await fetch(`${server}/CrmCampaniums`);
    //                 const data = await response.json();
    //                 setCampanias(data.$values);
                   
    //             } catch (error) {
    //                 Swal.fire({
    //                     icon: 'error',
    //                     title: 'Error',
    //                     text: 'Error al cargar las Campañas: ' + error,
    //                 });
    //             }
    //         };

    const fetchCampanias = async (idEstadoCampania = '') => {
        try {
            const url = idEstadoCampania
                ? `${server}/CrmCampaniums/poridEstado/${idEstadoCampania}`
                : `${server}/CrmCampaniums`;

            const response = await fetch(url);
            const data = await response.json();
            setCampanias(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar las Campañas: ' + error,
            });
        }
        };


    const fetchEstados = async () => {
                try {
                    const response = await fetch(`${server}/CrmEstadoCampaniums`);
                    const data = await response.json();
                    setEstados(data.$values);
                   
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar los estados: ' + error,
                    });
                }
            };            
        
            const handleEstadoFiltroChange = (event) => {
                setEstadoFiltro(event.target.value);
            };

            useEffect(() => {
            fetchEstados();
            fetchCampanias(); // por defecto todas
            }, []);

            useEffect(() => {
            fetchCampanias(estadoFiltro);
            }, [estadoFiltro]);
        
            const handleNewCampania = () => {
                fetchCampanias(estadoFiltro)
                setEditCampania(null);
            };

            const actualizarSoloCampania = () => {
                fetchCampanias(estadoFiltro);
            }
                    
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (campania) => {
                setCampaniaToDelete(campania);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setCampaniaToDelete(null);
            };
        
            const handleDeleteCampania = async () => {
                if (campaniaToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';
        
                        const response = await fetch(`${server}/CrmCampaniums/${campaniaToDelete.idCampania}/${username}`,
                             {
                            method: 'DELETE'
                        });
                        if (response.ok) {
                            handleCloseDialog();
                            fetchCampanias(); // Recargar la lista de campanias
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Campaña eliminada con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar la campaña:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar la campaña: ' + error,
                        });            }
                }
            };
        
            const filteredCampania = campanias.filter(campania => campania.tituloCampania?.toLowerCase().includes(searchQuery.toLowerCase()));
    
    const handleCancelarEdicion = () => {
        setEditCampania(null);
    };

return (
<>
    <div className="x_title"></div>
        <div className="x_content">
        <div className="row">
            
            <br />
            <div className="col-md-10 col-sm-4 offset-md-2">
            <br />
            <br />

            <div className="ln_solid" />

            <h2>Campañas existentes</h2>

           
            <Grid container spacing={2} alignItems="center" style={{ marginBottom: '20px' }}>
                <Grid item xs={12} sm={8}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Buscar Campaña"
                        placeholder="Buscar..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        
                     />
                    
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
               <TextField
                    select
                    fullWidth
                    label="Filtrar por Estado"
                    value={estadoFiltro}
                    onChange={(e) => setEstadoFiltro(e.target.value)}
                    variant="outlined"
                >
                    <MenuItem value="">Todos</MenuItem>
                    {estados.map((estado) => (
                        <MenuItem key={estado.id} value={estado.id}>
                            {estado.estado}
                        </MenuItem>
                    ))}
                </TextField>
                </Grid>
                
            </Grid>

                <div className="table-responsive">
                <TableContainer component={Paper}>
                    <Table>
                    <TableHead>
                        <TableRow>
                        <TableCell align="right">Acciones</TableCell>
                        <TableCell>Titulo</TableCell>
                        <TableCell>Descripcion</TableCell>
                        <TableCell>Fecha de Inicio</TableCell>
                        <TableCell>Fecha de finalización</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell>Promoción asociada</TableCell>
                        <TableCell><strong>Total Gasto</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredCampania.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((campania) => (
                            <TableRow key={campania.idCampania}>
                            <TableCell align="right">
                                <Button onClick={() => setEditCampania(campania)} color="primary" disabled={!tienePermiso('Editar Campaña')}>
                                    Editar
                                </Button>
                                <Button onClick={() => handleOpenDialog(campania)} color="secondary" disabled={!tienePermiso('Eliminar Campaña')}>
                                    Eliminar
                                </Button>
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {campania.tituloCampania}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {campania.decripcionCampania}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {campania.fechaInicio}
                            </TableCell>
                             <TableCell component="th" scope="row">
                                {campania.fechaFinalizacion}
                            </TableCell>
                            <TableCell component="th" scope="row">
                             <span style={{
                                padding: '4px 8px',
                                borderRadius: '5px',
                                color: 'white',
                                backgroundColor:
                                campania.estado?.toLowerCase() === 'planificada' ? 'lightgray' :
                                campania.estado?.toLowerCase() === 'activa' ? 'green' :
                                campania.estado?.toLowerCase() === 'finalizada' ? 'gray' :
                                campania.estado?.toLowerCase() === 'cancelada' ? 'red' :
                                campania.estado?.toLowerCase() === 'vencida' ? 'brown' :
                                ''
                                            
                                }}>
                                {campania.estado}
                            </span>
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {campania.promocion}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                <strong>{campania.totalGastos}</strong>
                            </TableCell>
                            </TableRow>
                           ))}                        
                    </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={campanias.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRateChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>
            </div>
                <div className="col-md-9 col-sm-4 offset-md-2">
                 <AddCampaña handleNewCampania={handleNewCampania} editCampania={editCampania} cancelarEdicion={handleCancelarEdicion} actualizarCampania={actualizarSoloCampania}/>
                </div>

                <Dialog open={openDialog}
                                                onClose={handleCloseDialog}
                                                aria-labelledby="alert-dialog-title"
                                                aria-describedby="alert-dialog-description">
                                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                                <DialogContent>
                                                    <DialogContentText id="alert-dialog-description">
                                                        ¿Estás seguro de que quieres eliminar esta campaña?
                                                    </DialogContentText>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                                    <Button onClick={handleDeleteCampania} color="primary" autoFocus>Eliminar</Button>
                                                </DialogActions>
                                            </Dialog>
            </div>
        </div>
    </>

     
    );
}

export default GestionCampaña;